import styled from '@emotion/styled';
import BEText from '@molecules/Text';

export const StyledCardContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 348px;
  border-radius: 16px;
  border: 1px solid #DDE0E4;
  overflow: hidden;
`;

export const StyledMainBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 16px;
`;

export const StyledTitle = styled(BEText)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const StyledPrice = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding-top: 4px;
  padding-bottom: 16px;
`;
